// ============================================
// QuickActions.jsx - FIXED VERSION
// ============================================
import {FiFolderPlus} from 'react-icons/fi';
import {FaRegUser} from 'react-icons/fa6';
import {RiHandCoinLine} from 'react-icons/ri';

import {Link} from 'react-router-dom';
import AddProject from './AddProject';
import {toast} from 'react-toastify';
import {useDispatch, useSelector} from 'react-redux';
import {setProjectList} from '../slices/app';
import api from '../Interceptor';
import {useState} from 'react';
import {getRoute} from '../api/routes';
import AddSubUser from './AddSubUser';
import useModal from '../hooks/useModal';
import AddExpense from '../pages/AddExpense';

const QuickActions = () => {
  const dispatch = useDispatch();
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);
  const [showAddTransactionModal, setShowAddTransactionModal] = useState(false);

  const {isOpen, toggleModal} = useModal();
  const [addUserModalVisible, setAddUserModalVisible] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const [users, setUsers] = useState([]);

  const fetchProjects = async () => {
    try {
      const response = await api.get(
        getRoute('users', 'admin', 'projects', false, false, '')
      );
      dispatch(setProjectList(response.data));
    } catch (error) {
      if (error?.isUnpaid) {
        return;
      }
      if (error.response && error.response.data) {
        toast.error(`Failed to fetch projects: ${error.response.data.message}`);
      } else {
        toast.error('An error occurred while fetching projects.');
      }
      console.error('Fetch projects error:', error);
    }
  };

  const handleSuccess = () => {
    setAddUserModalVisible(false);
  };

  const handleTransactionSuccess = () => {
    setShowAddTransactionModal(false);
  };

  const handleTransactionCancel = () => {
    setShowAddTransactionModal(false);
  };

  return (
    <div className="h-full w-full bg-white rounded-xl p-3 border border-[#D5D7DA] shadow-lg flex flex-col">
      {isOpen ? (
        <AddSubUser onSuccess={handleSuccess} onCancel={toggleModal} />
      ) : null}
      {showAddProjectModal && (
        <AddProject
          isOpen={showAddProjectModal}
          toggleModal={() => setShowAddProjectModal(false)}
          fetchProjects={fetchProjects}
        />
      )}
      {showAddTransactionModal && (
        <AddExpense
          onSuccess={handleTransactionSuccess}
          onCancel={handleTransactionCancel}
          isModalOpen={showAddTransactionModal}
        />
      )}

      {/* Header */}
      <div className="flex-shrink-0 mb-3">
        <p className="font-semibold font-customFont">Quick Actions</p>
      </div>

      {/* Cards Grid - fills remaining space */}
      <div className="flex-1 min-h-0">
        <div className="grid grid-cols-2 gap-3 h-full">
          {/* Card 1 - New Project */}
          <ActionCard
            icon={<FiFolderPlus className="text-2xl text-white" />}
            title="New Project"
            gradient="from-teal-500 to-teal-800"
            onClick={() => setShowAddProjectModal(true)}
          />

          {/* Card 2 - New Transaction */}
          <ActionCard
            icon={<RiHandCoinLine className="text-2xl text-white" />}
            title="New Transaction"
            gradient="from-blue-500 to-blue-800"
            onClick={() => setShowAddTransactionModal(true)}
          />

          {/* Card 3 - New Invoice */}
          <Link to="/createInvoice" className="h-full">
            <ActionCard
              icon={
                <i className="fa-regular fa-file-lines text-2xl text-white"></i>
              }
              title="New Invoice"
              gradient="from-yellow-500 to-yellow-800"
            />
          </Link>

          {/* Card 4 - Add Member */}
          <ActionCard
            icon={<FaRegUser className="text-2xl text-white" />}
            title="Add Member"
            gradient="from-pink-500 to-pink-800"
            onClick={toggleModal}
          />
        </div>
      </div>
    </div>
  );
};

// Reusable Action Card Component
const ActionCard = ({icon, title, gradient, onClick}) => {
  return (
    <div
      className="h-full rounded-lg border border-[#E5E7EB] bg-[#f7f8fa] p-3 flex flex-col items-center justify-center gap-3 cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClick}
    >
      <div
        className={`w-12 h-12 rounded-lg bg-gradient-to-br ${gradient} flex items-center justify-center`}
      >
        {icon}
      </div>
      <p className="text-gray-600 font-semibold text-sm text-center">{title}</p>
    </div>
  );
};

export default QuickActions;
